export const bulkBtnCls =
  "rounded-full border border-slate-300 bg-white px-4 py-1.5 text-xs font-semibold text-slate-600 transition-colors duration-200 hover:border-royal hover:text-royal";

export const BulkBar = ({ count, onClear, testId, children }) => {
  if (!count) return null;
  return (
    <div
      className="mt-3 flex flex-wrap items-center gap-2 rounded-2xl border border-royal/30 bg-royal-light px-5 py-3"
      data-testid={testId}
    >
      <span className="mr-1 text-xs font-bold text-royal" data-testid={`${testId}-count`}>
        {count} selected
      </span>
      {children}
      <button
        onClick={onClear}
        data-testid={`${testId}-clear`}
        className="ml-auto text-xs font-semibold text-slate-500 transition-colors duration-200 hover:text-ink"
      >
        Clear
      </button>
    </div>
  );
};
